import "../IntroPage/intropage.css";

import React, { useEffect, useRef, useState } from "react";

import Container from "react-bootstrap/Container";
// import modalImg from "../../imgs/GraphHelp.png";
import modalText from "../../data/modalText.json";

export function HelpModal() {
  const [showModal, setShowModal] = useState(false);
  const modalRef = useRef(null);

  const handleToggleModal = () => setShowModal(!showModal);

  const handleClickOutside = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      setShowModal(false);
    }
  };

  useEffect(() => {
    if (showModal) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showModal]);

  return (
    <Container
      style={{
        position: "relative",
        top: "20%",
        paddingLeft: "60%",
      }}
    >
    
      {/* little “?” button stays in flow wherever you render HelpModal */}
      <button className="question-button" onClick={handleToggleModal}>?</button>

      {showModal && (
        <>
          <div className="modal-overlay" onClick={handleToggleModal} />

          <div ref={modalRef} className="tutorial-popup-container">
            <div className="tutorial-popup-content">

              {/* ─── Close-window X ─── */}
              <button
                className="close-modal"
                aria-label="Close"
                onClick={handleToggleModal}
              >
                &times;
              </button>

              {/* Help text & image */}
              <h3 className="mb-3">Simple Case List</h3>
              <div dangerouslySetInnerHTML={{ __html: modalText.caselist }} />
              {/* <img
                src={modalImg}
                alt="Overlap graph help"
                style={{ maxWidth: "100%", marginTop: "1rem" }}
              /> */}
            </div>
          </div>
        </>
      )}
    </Container>
  );
}